function fixMail(d) {
    const mail = "mailto:" + atob("ZGVsdGEuYml1cm9Ab25ldC5wbA==");
    const mails = d.getElementsByClassName("e-mail");
    for(var i = 0; i < mails.length; i++)mails[i].setAttribute("href", mail);
}
function isReduceMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function fadeIn(el) {
    el.classList.add("fade-in");
    el.classList.remove("has-animate");
}
function sectionAnimation(document1) {
    if (isReduceMotion()) return;
    let main = document1.querySelector("main");
    const cfg = {
        threshold: 0,
        rootMargin: "-50px"
    };
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                setTimeout(()=>{
                    fadeIn(entry.target);
                }, 100);
                observer.unobserve(entry.target);
            }
        });
    }, cfg);
    const sections = main.childNodes;
    sections.forEach((section)=>{
        if (section.nodeType === Node.ELEMENT_NODE && section.nodeName !== "HR" && section.nodeName !== "SVG") {
            const rect = section.getBoundingClientRect();
            const belowViewport = rect.top > window.innerHeight;
            if (belowViewport) {
                console.log("add", section);
                section.classList.add("has-animate");
                observer.observe(section);
            }
        }
    });
}
fixMail(document);
sectionAnimation(document);

//# sourceMappingURL=index.1d1035f3.js.map
